export const DEFAULT_CONFIG = {
  position: 'bottom-left',
  autoClose: 10000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: false,
};
